import { z } from 'zod';

export const VENDOR_PAYMENT_MODES = ['CHECK', 'ECHECK'] as const;

export const VendorApplyPaymentSchema = z
  .object({
    paymentMode: z.string({ message: 'Mode of Payment is required' }),
    paymentAmount: z.string().nullish(),
    checkNumber: z.string().nullish(),
    invoiceIds: z.array(z.string()).nullish(),
  })
  .superRefine((data, ctx) => {
    if (!VENDOR_PAYMENT_MODES.includes(data.paymentMode as (typeof VENDOR_PAYMENT_MODES)[number])) {
      ctx.addIssue({
        code: 'custom',
        message: 'Mode of Payment must be Check or E-check',
        path: ['paymentMode'],
      });
    }

    if (data.paymentMode === 'CHECK' || data.paymentMode === 'ECHECK') {
      if (!data.checkNumber?.trim()) {
        ctx.addIssue({
          code: 'custom',
          message: 'Check number is required for Check and E-check payment modes',
          path: ['checkNumber'],
        });
      } else if (!/^\d{1,20}$/.test(data.checkNumber.trim())) {
        ctx.addIssue({
          code: 'custom',
          message: 'Check number must be digits only and up to 20 characters',
          path: ['checkNumber'],
        });
      }
    }

    if (!data.invoiceIds || data.invoiceIds.length === 0) {
      ctx.addIssue({
        code: 'custom',
        message: 'At least one invoice must be selected',
        path: ['invoiceIds'],
      });
    }

    if (data.paymentAmount === null || data.paymentAmount === undefined || data.paymentAmount === '') {
      ctx.addIssue({
        code: 'custom',
        message: 'Amount is required',
        path: ['paymentAmount'],
      });
    } else {
      const amount = parseFloat(data.paymentAmount);
      if (isNaN(amount) || amount <= 0) {
        ctx.addIssue({
          code: 'custom',
          message: 'Amount must be a positive number',
          path: ['paymentAmount'],
        });
      }
    }
  });

export type VendorApplyPaymentFormData = z.infer<typeof VendorApplyPaymentSchema>;
